const myData = {
    resumeLink: "https://drive.google.com/file/d/1ARjUFSgZ9M6RqigEjr671hKWqIg7sfIt/view?usp=sharing"
}

export default myData;